// client/src/pages/History/CustomerHistory.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HistoryInterface from "../../components/HistoryInterface";

const CustomerHistory = () => {
  const navigate = useNavigate();
  const [brandInfo, setBrandInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    // Check authentication
    const token = localStorage.getItem("brandToken");
    const brandCode = localStorage.getItem("brandCode");
    const brandName = localStorage.getItem("brandName");

    if (!token || !brandCode) {
      navigate("/brand-login");
      return;
    }

    // Set brand info from localStorage
    setBrandInfo({
      brandCode,
      brandName: brandName || brandCode,
    });

    setLoading(false);
  }, [navigate]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "#f5f7fa",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e1e1e1",
            borderTop: "4px solid #667eea",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "#f5f7fa",
          color: "#e74c3c",
          textAlign: "center",
        }}
      >
        <h2>Error</h2>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  if (!brandInfo) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "#f5f7fa",
          color: "#e74c3c",
          textAlign: "center",
        }}
      >
        <h2>Authentication Required</h2>
        <p>Please log in to access your brand dashboard.</p>
        <button onClick={() => navigate("/brand-login")}>Go to Login</button>
      </div>
    );
  }

  // Return ONLY the HistoryInterFace without any wrapper
  return (
    <div style={{ height: "100vh", width: "100vw" }}>
      <HistoryInterface
        brandFilter={brandInfo.brandCode}
        showBrandHeader={false}
      />
    </div>
  );
};

export default CustomerHistory;
